var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.083,
    height: 27.083,
    viewBox: "0 0 27.083 27.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5666",
    "data-name": "Group 5666",
    transform: "translate(-285.56 -476.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coin",
    transform: "translate(285.56 476.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.67,0V4.175c0,3.521-3.284,6.376-7.335,6.376S0,7.7,0,4.175V0C0,3.521,3.284,6.037,7.335,6.037S14.67,3.521,14.67,0Z",
    transform: "translate(6.207 14.275)",
    fill: "none",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M14.67,6.376a5.308,5.308,0,0,1-.779,2.787,7.542,7.542,0,0,1-6.556,3.25A7.542,7.542,0,0,1,.779,9.163,5.308,5.308,0,0,1,0,6.376a5.974,5.974,0,0,1,2.144-4.5A7.869,7.869,0,0,1,7.335,0a7.92,7.92,0,0,1,5.191,1.862A6.016,6.016,0,0,1,14.67,6.376Z",
    transform: "translate(6.207 2.257)",
    fill: "none",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M14.67,6.376v5.642c0,3.521-3.284,6.037-7.335,6.037S0,15.539,0,12.018V6.376C0,2.855,3.284,0,7.335,0a7.92,7.92,0,0,1,5.191,1.862A6.016,6.016,0,0,1,14.67,6.376Z",
    transform: "translate(6.207 2.257)",
    fill: "none",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector-4",
    "data-name": "Vector",
    transform: "translate(0 0)",
    fill: "none",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H27.083V27.083H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.299999237060547 1.299999237060547 L 1.299999237060547 25.78349876403809 L 25.78349876403809 25.78349876403809 L 25.78349876403809 1.299999237060547 L 1.299999237060547 1.299999237060547 M -1.9073486328125e-06 -1.9073486328125e-06 L 27.08349990844727 -1.9073486328125e-06 L 27.08349990844727 27.08349990844727 L -1.9073486328125e-06 27.08349990844727 L -1.9073486328125e-06 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#707070"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.76afaf5917ecfddd0cbc0d09a464d152.svg";
export { ForwardRef as ReactComponent };